import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import Picture from 'components/picture';
import { useFeatureLayout } from 'hooks/use-feature-layout';
import { useUIContext } from 'state/ui';

import { Balance, CurrencySymbol, HeaderContainer, TimCardTextImageContainer } from './styled';

interface IHeader {
  balance?: string;
}

const Header: FC<IHeader> = ({ balance }) => {
  const { formatMessage } = useIntl();

  const { featureLayout } = useFeatureLayout();
  const { currencySymbol, currencyIsSuffix } = useUIContext();

  const timCardTextIconAsset = featureLayout?.giftCardTextImage?.locale;

  const CurrentCurrencySymbol = () => <CurrencySymbol>{currencySymbol}</CurrencySymbol>;

  return (
    <HeaderContainer>
      <TimCardTextImageContainer>
        <Picture
          image={timCardTextIconAsset}
          alt={formatMessage({ id: 'timCard' })}
          objectFitContain={true}
        />
      </TimCardTextImageContainer>
      <Balance data-testid="balance">
        {!currencyIsSuffix && <CurrentCurrencySymbol />}
        {balance}
        {currencyIsSuffix && <CurrentCurrencySymbol />}
      </Balance>
    </HeaderContainer>
  );
};

export default Header;
